<template >
    <div style="margin-left: 10px">
        <template v-for="menu in menus">
            <el-button :type="menu.css==''?'primary':menu.css"  @click="handleclick(menu.linkurl)" :key="menu.id" v-if="ignore_ids.indexOf(','+menu.id+',')<0">
                {{menu.name}}
            </el-button>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        menu_id: {
            type: Number,
            default() {
                return 0
            }
        },
        menus: {
            type: Array,
            default() {
                return 0
            }
        },
        ignore_ids: {
            type: String,
            default() {
                return ''
            }
        }
    },
    methods: {
        handleclick(params){
            this.$emit('on_btnclk',params);
        },
    }
}
</script>